// Note:
// Inside each key, the elements should be ordered alphabetically

export const ResourcesEN = {
    // Elements
    label: {
        advance: 'Advance',
        anotherTopic: 'Another topic',
        campusAccess: 'Access',
        campusBuildings: 'Buildings',
        campusEnergy: 'Energy',
        campusGreenSpaces: 'Green Spaces',
        campusParking: 'Gates and Parking',
        campusWaste: 'Waste',
        campusWatersSewers: 'Waters and Sewers',
        campusWifi: 'Wi-Fi',
        /*
        campusAccess: 'Campus Access',
        campusBuildings: 'Campus Buildings',
        campusEnergy: 'Campus Energy',
        campusGreenSpaces: 'Campus Green Spaces',
        campusParking: 'Campus Gates and Parking',
        campusWaste: 'Campus Waste',
        campusWatersSewers: 'Campus Waters and Sewers',
        campusWifi: 'Campus Wi-Fi',
        */
        cancel: 'Cancelar',
        configurations: 'Configurations',
        doLogin: 'Login',
        endSession: 'Log out',
        endSessionQuestion: 'Do you want to log out of the application?',
        exitApp: 'Exit the app',
        forgotPassword: 'Forgot your Password?',
        haveAnAccount: 'Already have an account',
        hello: 'Hello',
        incidents: 'Incidents',
        inMyIncidents: 'In my incidents',
        iReadAndAccept: `I've read and accept`,
        leaveComment: 'Leave comment',
        loading: 'Loading',
        login: 'Login',
        loginNova: 'Login NOVA',
        logout: 'Log out',
        map: {
            confirmYourLocation: 'Confirm your location',
            continueWithLocation: 'Continue with this location',
            outsideCampusLocation: 'The selected location appears to be off-campus',
            useMyLocation: 'Use my location',
        },
        my: 'My',
        myIncidents: 'My reports',
        newReport: 'New Report',
        newUser: 'New user',
        noIncidents: 'No incidents',
        noIncidentInThisState: 'There are no incidents reported in this state',
        orConnectWith: 'or connect with',
        register: 'Register',
        registerMe: 'Register me',
        reopenIncident: 'Reopen incident',
        reportIncident: 'Report the incident',
        reports: 'Reports',
        severity: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            warningLow: 'Need for revision, but not limiting.',
            warningMedium: 'Need for urgent review, but not impeding.',
            warningHigh: 'Need for immediate review. Unavailable service.',
        },
        showYourLocation: 'Show your location',
        status: {
            canceled: 'Canceled',
            closed: 'Closed',
            inProgress: 'In progress',
            inValidation: 'In validation',
            hold: 'Hold',
            registered: 'Registered',
            resolved: 'Resolved',
            transferred: 'Transferred',
        },
        termsAndConditions: 'Terms and conditions',
        tryAgain: 'Try again',
        universityLocation: 'University location',
        uploadPhoto: 'Upload Photo',
        viewPending: 'View Pending',
    },
    title: {
        welcomeToApp: 'Welcome to the reporting APP',
        smartCampusCampolide: 'Smart Campus Campolide',
    },

    // Pages & Screens
    details: {
        followResolution: `It's this one. Follow resolution`,
        doesIncidentOccur: 'Does this incident still occur?',
    },
    home: {
        title: 'Did you encounter any problems today?',
        paragraph: 'Center the map on the incidence site',
        pwaPrompt: {
            description: 'Add this app to your home screen to quickly report incidents',
            cta: 'Add app',
        },
    },
    login: {
        heading: 'Do you belong to the NOVA community?',
        paragraph: 'Register with your institutional email',
    },
    noMatch: {
        ctaText: 'Return to home page',
        description: 'The page you are looking for does not exist or is currently unavailable.',
        title: `It looks like this page doesn't exist`,
    },
    pending: {
        bannerTitle: 'Pending',
        title: 'Incidents reported on Campus:',
    },
    profile: {
        tabs: {
            ongoingResolution: 'Ongoing resolution',
            open: 'Open',
            resolved: 'Resolved',
            underAnalysis: 'Under analysis',
        },
    },
    report: {
        bannerTitle: 'Report an incident',
        step1: {
            checkingReportedIncidents: 'Checking for reported incidents...',
            ctaText: 'I did not find my reported incident',
            title1: 'Choose the topic on which you want to report an incident.',
            title2: 'There are already reported incidents similar to yours, check if it is one of these:',
        },
        step2: {
            title: 'Tell us some details about the incident.',
        },
        step3: {
            title: 'Add a photograph of the incident (Optional)',
            warningMessage: 'The image you tried to insert does not have the correct specifications. Try again.',
        },
    },
    splashScreen: {
        description: 'With your help, we made the NOVA University Campus a better space',
    },

    // Forms
    form: {
        confirmPwd: {
            label: 'Confirm Password',
            placeholder: 'Confirm Password',
            validate: {
                required: 'Confirm password is mandatory',
                validate: `Your passwords don't match`,
            },
        },
        email: {
            label: 'Email',
            placeholder: 'Email',
            validate: {
                required: 'Email is mandatory',
                pattern: 'Invalid email',
            },
        },
        name: {
            label: 'Name',
            placeholder: 'Name',
            validate: {
                required: 'Name is mandatory',
            },
        },
        password: {
            label: 'Password',
            placeholder: 'Password',
            validate: {
                required: 'Password is mandatory',
                pattern:
                    'Your password must contain an uppercase letter, a lowercase letter, a number, a special character and at least 8 characters.',
            },
        },
        reopenIncident: {
            label: 'Reopen incident',
            placeholder: 'Leave a comment telling us why you want to reopen this incident',
            validate: {
                required: 'Reopening incident is mandatory',
            },
        },

        // Report Form
        report: {
            description: {
                label: 'Description',
                placeholder: 'Description*',
                validate: {
                    required: "Description is mandatory",
                }
            },
            dropdown: {
                label: 'How do you characterize this incident?',
                placeholder: 'How do you characterize this incident?',
            },
            severity: {
                label: 'How important is this incident?',
                placeholder: 'How important is this incident?',
            },
            title: {
                infoMessage: 'Write something short and simple like “Burn out lightbulb” or “Hole in the floor',
                label: 'Title',
                placeholder: 'Title',
                validate: {
                    required: 'Title is mandatory',
                },
            },
        },
        username: {
            label: 'Username',
            placeholder: 'Username',
            validate: {
                required: 'Username is mandatory',
                pattern: 'Invalid Username',
            },
        },
    },

    // Feedback Messages
    feedback: {
        successTitle: 'Success!',
        errorTitle: 'Oops! Something went wrong.',
        report: {
            errorDescription1: `We're sorry, but we were unable to report your incident. Please try again later.`,
            errorDescription2: 'We are sorry, but we were unable to follow the incident. Please try again later',
            successDescription1: 'You can track your report status on your profile.',
            successTitle: 'Thanks for your report!',
            successTitleReopen: 'Incident reopened!',
        },
    },
};
